// Connecting navigates the whole page away to Google, so the only way to know
// a rep came back WITHOUT finishing is to leave a marker behind before leaving
// and look for it on the way back. sessionStorage survives the round trip and
// dies with the tab, which is exactly the lifetime wanted here.
const PENDING_KEY = 'zeph:google-workspace:pending-connect'

// Matches the backend's OAuth state TTL — past this the attempt is dead anyway,
// so an older marker is stale (e.g. a tab restored the next morning) and is
// ignored rather than firing a confusing toast.
const PENDING_MAX_AGE_MS = 10 * 60 * 1000

export function markConnectPending(): void {
  try {
    sessionStorage.setItem(PENDING_KEY, String(Date.now()))
  } catch {
    // Private mode / blocked storage — abandonment just goes undetected.
  }
}

export function clearConnectPending(): void {
  try {
    sessionStorage.removeItem(PENDING_KEY)
  } catch { /* nothing to clean up if storage is unavailable */ }
}

/** True when a connect was started but never came back with an outcome. Consumes the marker. */
export function takeAbandonedConnect(): boolean {
  let raw: string | null = null
  try {
    raw = sessionStorage.getItem(PENDING_KEY)
  } catch {
    return false
  }
  if (!raw) return false
  clearConnectPending()
  const startedAt = Number(raw)
  return Number.isFinite(startedAt) && Date.now() - startedAt <= PENDING_MAX_AGE_MS
}
